export enum AccountPermissions {
    BillingView = 'billingview',
    BillingEdit = 'billingedit',
    BillingEditApprovedAppointments = 'billingeditapprovedappointments',
    BillingApprove = 'billingapprove',
    BillingSubmitClaims = 'billingsubmitclaims',
    BillingPostPayments = 'billingpostpayments',
    BillingReopenEncounter = 'billingreopenencounter',//Patient Invoicing
    BillingCloseEncounters = 'billingcloseencounters',//Reporting
    BillingClientHistory = 'billingclienthistory',//Client History
    BillingEditPatientInvoicing = 'billingeditpatientinvoicing',//Patient Invoicing

}
